import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary text-white mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_63b0521a-b192-4372-9aea-5b9cab43c9ba/artifacts/ofzxk3s3_FB_IMG_1770212470970.jpg" 
                alt="Aarogya ENT Clinic Logo" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              {t('footer.aboutText')}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-link-about">{t('nav.about')}</Link></li>
              <li><Link to="/services" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-link-services">{t('nav.services')}</Link></li>
              <li><Link to="/blog" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-link-blog">{t('nav.blog')}</Link></li>
              <li><Link to="/faq" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-link-faq">{t('nav.faq')}</Link></li>
              <li><Link to="/contact" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-link-contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li>ENT Consultation</li>
              <li>ENT Endoscopy</li>
              <li>Allergy Testing</li>
              <li>Vertigo Assessment</li>
              <li>Audiometry</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t('footer.contactInfo')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <a href="https://share.google/tkb47jzKDeiANfZNX" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors">
                  {t('contact.info.address')}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={18} />
                <div className="flex flex-col">
                  <a href="tel:03715222367" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-phone">03715222367</a>
                  <a href="tel:9864815487" className="text-sm text-white/80 hover:text-white transition-colors">9864815487</a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} />
                <a href="mailto:aarogyaent@gmail.com" className="text-sm text-white/80 hover:text-white transition-colors" data-testid="footer-email">{t('contact.info.email')}</a>
              </li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a href="https://www.facebook.com/share/1AnHnZHnXN/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-facebook" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/aarogyaent?igsh=eGMyeGRhZTJ4MGhv" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-instagram" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://share.google/tkb47jzKDeiANfZNX" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors" data-testid="footer-maps" aria-label="Google Maps">
                <MapPin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-6">
          <div className="bg-white/5 rounded-lg p-6 mb-6">
            <p className="text-sm text-white/90 mb-3 font-semibold">
              ⚠️ Important Notice:
            </p>
            <p className="text-sm text-white/80 mb-2">
              • Kindly confirm your appointment before visiting clinic by calling at clinic number.
            </p>
            <p className="text-sm text-white/80">
              • <strong>Beware of Frauds:</strong> Kindly don't share your password, OTP's, banking details or make any advance payment for booking your appointment over telephone or any messaging app.
            </p>
          </div>
          <p className="text-sm text-white/60 text-center">
            © {new Date().getFullYear()} Aarogya ENT Clinic. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}
